module.exports = __webpack_public_path__ + "img/empty-img@3x.92c52b39.png";